export class FeatureFlagState {
    featureFlags: Array<ProxyModel.FeatureFlagViewModel>;
}
